import React, { useState, useEffect } from 'react'
import { Card, Button, List, Checkbox, message, Modal, Tag, Space } from 'antd'
import { PlayCircleOutlined, EnvironmentOutlined, ClockCircleOutlined } from '@ant-design/icons'
import axios from 'axios'

function RoutePlanning({ customers, onRouteUpdate }) {
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [routeResult, setRouteResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [routeModalVisible, setRouteModalVisible] = useState(false)

  useEffect(() => {

    console.log('pendingCustomers', pendingCustomers)

  }, [customers])

  // 筛选待处理的客户
  const pendingCustomers = customers.filter(customer => customer.status === 'pending')

  const handleCustomerSelect = (customerId, checked) => {
    if (checked) {
      setSelectedCustomers(prev => [...prev, customerId])
    } else {
      setSelectedCustomers(prev => prev.filter(id => id !== customerId))
    }
  }

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedCustomers(pendingCustomers.map(customer => customer._id))
    } else {
      setSelectedCustomers([])
    }
  }

  const handlePlanRoute = async () => {
    if (selectedCustomers.length === 0) {
      message.warning('请至少选择一个客户进行路线规划')
      return
    }

    setLoading(true)
    try {
      const response = await axios.post('/api/route-plan', {
        customer_ids: selectedCustomers
      })
      
      setRouteResult(response.data)
      setRouteModalVisible(true)
      message.success('路线规划完成')
    } catch (error) {
      message.error('路线规划失败')
    }
    setLoading(false)
  }

  const handleStartNavigation = (customer) => {
    // 这里可以集成高德地图导航
    message.info(`开始导航到 ${customer.name}，地址：${customer.address}`)
    
    // 模拟导航开始
    Modal.info({
      title: '导航信息',
      content: `正在为您导航到：${customer.name}\n地址：${customer.address}`,
      okText: '开始导航'
    })
  }


  return (
    <div className="route-planning">
      <Card 
        title="智能路线规划" 
        className="route-card"
        extra={
          <div className="route-actions">
            <Checkbox
              onChange={e => handleSelectAll(e.target.checked)}
              checked={selectedCustomers.length === pendingCustomers.length && pendingCustomers.length > 0}
              indeterminate={selectedCustomers.length > 0 && selectedCustomers.length < pendingCustomers.length}
            >
              全选
            </Checkbox>
            <Button 
              type="primary" 
              icon={<PlayCircleOutlined />}
              onClick={handlePlanRoute}
              loading={loading}
              disabled={selectedCustomers.length === 0}
            >
              规划路线
            </Button>
          </div>
        }
      >
        <div className="customer-selection">
          <List
            dataSource={pendingCustomers}
            renderItem={customer => (
              <List.Item className="customer-item">
                <div className="customer-info">
                  <Checkbox
                    checked={selectedCustomers.includes(customer._id)}
                    onChange={e => handleCustomerSelect(customer._id, e.target.checked)}
                  >
                    <Space direction="vertical" size="small">
                      <div className="customer-name">{customer.name}</div>
                      <div className="customer-details">
                        <Tag icon={<EnvironmentOutlined />} color="blue">
                          {customer.address}
                        </Tag>
                        <Tag icon={<ClockCircleOutlined />} color="orange">
                          {customer.appointment_time}
                        </Tag>
                        {customer.remark && (
                          <Tag color="purple">
                            备注: {customer.remark}
                          </Tag>
                        )}
                      </div>
                    </Space>
                  </Checkbox>
                </div>
                
                <div className="customer-actions">
                  <Button 
                    type="link" 
                    icon={<EnvironmentOutlined />}
                    onClick={() => handleStartNavigation(customer)}
                    size="small"
                  >
                    导航
                  </Button>

                </div>
              </List.Item>
            )}
            locale={{ emptyText: '暂无待处理的客户' }}
          />
        </div>

        {selectedCustomers.length > 0 && (
          <div className="selection-summary">
            <Tag color="green">已选择 {selectedCustomers.length} 个客户</Tag>
          </div>
        )}
      </Card>

      {/* 路线规划结果模态框 */}
      <Modal
        title="智能路线规划结果 - 上海客户拜访路线"
        open={routeModalVisible}
        onCancel={() => setRouteModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setRouteModalVisible(false)}>
            关闭
          </Button>
        ]}
        width={1000}
      >
        {routeResult && (
          <div className="route-result">
            {/* 缓存状态提示 */}
            {routeResult.is_cached !== undefined && (
              <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: routeResult.is_cached ? '#f6ffed' : '#fff7e6', borderRadius: '6px' }}>
                <Tag color={routeResult.is_cached ? "green" : "orange"}>
                  {routeResult.is_cached ? "💾 使用缓存结果（相同客户组合）" : "🔄 重新计算路线"}
                </Tag>
                <span style={{ marginLeft: '8px', fontSize: '14px' }}>
                  {routeResult.is_cached ? "相同客户组合，直接使用缓存结果，节省API调用" : "客户组合有变化，重新调用AI进行路线规划"}
                </span>
              </div>
            )}
            
            {/* 总体概览 */}
            {routeResult.route.overall_summary && (
              <div className="route-summary" style={{ padding: '16px', backgroundColor: '#f0f8ff', borderRadius: '8px', marginBottom: '20px' }}>
                <h4>📋 总体行程概览</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginTop: '12px' }}>
                  <div>
                    <p><strong>📅 总天数：</strong>{routeResult.route.overall_summary.total_days}</p>
                    <p><strong>👥 总客户数：</strong>{routeResult.route.overall_summary.total_customers}</p>
                  </div>
                  <div>
                    <p><strong>⏱️ 总行程时间：</strong>{routeResult.route.overall_summary.total_travel_time}</p>
                    {routeResult.route.overall_summary.weather_advice && (
                      <p><strong>🌤️ 天气建议：</strong>{routeResult.route.overall_summary.weather_advice}</p>
                    )}
                  </div>
                </div>
                <p style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
                  <strong>💡 规划原则：</strong>严格遵守预约时间刚性约束，不同日期客户分开安排
                </p>
              </div>
            )}
            
            {/* 按日期分组的路线规划 */}
            {routeResult.route.date_groups && Object.entries(routeResult.route.date_groups).map(([date, dayPlan]) => (
              <div key={date} className="day-plan" style={{ marginBottom: '30px', padding: '20px', border: '1px solid #e8e8e8', borderRadius: '8px' }}>
                <h4 style={{ color: '#1890ff', marginBottom: '16px', borderBottom: '2px solid #1890ff', paddingBottom: '8px' }}>
                  📅 {date} - 路线规划
                </h4>
                
                <div style={{ marginBottom: '16px', padding: '16px', backgroundColor: '#f0f8ff', borderRadius: '6px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    <div><strong>预计用时：</strong>{dayPlan.estimated_time}</div>
                    <div><strong>总距离：</strong>{dayPlan.total_distance}</div>
                    {dayPlan.weather_suggestion && (
                      <div><strong>天气建议：</strong>{dayPlan.weather_suggestion}</div>
                    )}
                  </div>
                  <p style={{ marginTop: '8px' }}><strong>路线描述：</strong>{dayPlan.route_description}</p>
                </div>
                
                {/* 地铁线路详情 */}
                {dayPlan.subway_routes && dayPlan.subway_routes.length > 0 && (
                  <div style={{ marginBottom: '20px', padding: '16px', backgroundColor: '#fff7e6', borderRadius: '6px' }}>
                    <h5 style={{ marginBottom: '12px', color: '#d46b08' }}>🚇 地铁线路详情</h5>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
                      {dayPlan.subway_routes.map((route, index) => (
                        <div key={index} style={{ padding: '8px', backgroundColor: 'white', borderRadius: '4px' }}>
                          <div><strong>路线 {index + 1}：</strong>{route.from} → {route.to}</div>
                          <div><strong>线路：</strong>{route.line}</div>
                          {route.stations && <div><strong>途经：</strong>{route.stations}</div>}
                          <div><strong>时间：</strong>{route.time}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="route-order">
                  <h5 style={{ marginBottom: '12px', color: '#389e0d' }}>🗺️ 详细时间安排（按顺序排列）</h5>
                  <List
                    dataSource={dayPlan.optimized_order.map((id, index) => {
                      const customer = routeResult.customers.find(c => c._id === id)
                      const timeInfo = dayPlan.time_breakdown ? 
                        dayPlan.time_breakdown.find(t => t.customer_id === id) : null
                      return customer ? { 
                        ...customer, 
                        order: index + 1,
                        timeInfo: timeInfo
                      } : null
                    }).filter(Boolean)}
                    renderItem={customer => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<span className="order-number" style={{ 
                            display: 'inline-block', 
                            width: '30px', 
                            height: '30px', 
                            lineHeight: '30px', 
                            textAlign: 'center', 
                            backgroundColor: '#1890ff', 
                            color: 'white', 
                            borderRadius: '50%',
                            fontWeight: 'bold'
                          }}>{customer.order}</span>}
                          title={
                            <div>
                              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{customer.name}</span>
                              {customer.timeInfo && (
                                <Tag color="blue" style={{ marginLeft: '8px' }}>
                                  预约：{customer.timeInfo.appointment_time}
                                </Tag>
                              )}
                              <Tag color="green" style={{ marginLeft: '8px' }}>
                                第 {customer.order} 站
                              </Tag>
                            </div>
                          }
                          description={
                            <div style={{ lineHeight: '1.8' }}>
                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px', marginBottom: '8px' }}>
                                <p><strong>🏠 地址：</strong>{customer.address}</p>
                                <p><strong>📞 电话：</strong>{customer.phone}</p>
                                <p><strong>📦 套餐：</strong>{customer.package_type}</p>
                              </div>
                              
                              {customer.timeInfo && (
                                <div style={{ marginTop: '8px', padding: '12px', backgroundColor: '#f6ffed', borderRadius: '4px' }}>
                                  <h6 style={{ marginBottom: '8px', color: '#389e0d' }}>⏰ 时间安排</h6>
                                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
                                    <div><strong>建议到达：</strong>{customer.timeInfo.estimated_arrival}</div>
                                    <div><strong>预计离开：</strong>{customer.timeInfo.estimated_departure}</div>
                                    <div><strong>业务时长：</strong>{customer.timeInfo.business_duration}分钟</div>
                                    <div><strong>通勤时间：</strong>{customer.timeInfo.travel_time}</div>
                                  </div>
                                  <div style={{ marginTop: '8px' }}>
                                    <strong>🚇 交通方式：</strong>{customer.timeInfo.transportation}
                                  </div>
                                  {customer.timeInfo.notes && (
                                    <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#e6f7ff', borderRadius: '4px' }}>
                                      <strong>📝 备注：</strong>{customer.timeInfo.notes}
                                    </div>
                                  )}
                                </div>
                              )}
                              
                              {customer.remark && <p><strong>📌 初始备注：</strong>{customer.remark}</p>}
                              
                              <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#fff7e6', borderRadius: '4px' }}>
                                <p style={{ fontSize: '12px', color: '#666' }}>
                                  <strong>💼 业务员提醒：</strong>完成拜访后请记录客户姓名、开卡时间、联系电话，并上传现场照片作为凭证。
                                </p>
                              </div>
                            </div>
                          }
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <Button 
                            type="primary" 
                            icon={<EnvironmentOutlined />}
                            onClick={() => handleStartNavigation(customer)}
                            size="small"
                          >
                            导航
                          </Button>

                        </div>
                      </List.Item>
                    )}
                  />
                </div>
              </div>
            ))}
            
            <div className="route-tips" style={{ marginTop: '20px', padding: '16px', backgroundColor: '#f0f8ff', borderRadius: '6px' }}>
              <h4>💡 核心规划规则提醒</h4>
              <ul style={{ margin: '8px 0', paddingLeft: '20px', fontSize: '14px' }}>
                <li><strong>规则1：</strong>严格遵守预约时间，严禁提前拜访</li>
                <li><strong>规则2：</strong>按业务类型预留时间（咨询30min，转网40min，集团60min）</li>
                <li><strong>规则3：</strong>不同日期客户绝对分开安排</li>
                <li><strong>规则4：</strong>同一日期内优先安排邻近区域客户</li>
                <li><strong>上海特色：</strong>跨江预留时间，避开高峰期长距离移动</li>
                <li><strong>地铁优化：</strong>详细说明具体地铁线路和换乘方案</li>
                <li><strong>天气适应：</strong>根据天气情况给出出行建议</li>
              </ul>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default RoutePlanning